const PrivacyPolicy = () => {
	
	return (
	  <div className="w-full h-screen flex items-center justify-center">
		<h1 className="font-interMedium text-2xl text-[#101828]">Privacy Policy</h1>
	  </div>
	);
  };
  
  export default PrivacyPolicy;